// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"87":"2791e6208f44cbcde05e","123":"0ec53e9aba9c66198707","207":"783926bee488096de90b","324":"29d8e07455b573ac8f59","556":"2d62ac2eda5075d68fe3","923":"47efdd9f3320c173d7c4"}[chunkId] + ".bundle.js";
};